import {graph2, api} from '../utils/shared'

export const all_departure_points = async(token) => {
    token = process.env.REACT_APP_GRAPHQL_BEARER_ENG;
    let q = `{all_departure_points {result}}`
    let x = await graph2(q, token)
    return x
}
